module.exports = __webpack_public_path__ + "static/media/4738654.1ceeec57.png";